// removed by extract-text-webpack-plugin
module.exports = {"gwCoverage":"ReadonlyCoverages-hashed__gwCoverage__1F1Cz","gwCoverage_last":"ReadonlyCoverages-hashed__gwCoverage_last__3ilBM","gwCoverage__name":"ReadonlyCoverages-hashed__gwCoverage__name__OtSrv","gwCoverage__terms":"ReadonlyCoverages-hashed__gwCoverage__terms__2iyMZ","gwCoverage__term":"ReadonlyCoverages-hashed__gwCoverage__term__301Rv","gwCoverage__termName":"ReadonlyCoverages-hashed__gwCoverage__termName__PgneD","gwCoverage__termAmount":"ReadonlyCoverages-hashed__gwCoverage__termAmount__X-4DK"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/readonlycoverages/ReadonlyCoverages-hashed.scss
// module id = 1230
// module chunks = 0